import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const BankTransferExitConfirm = ({ open, onStay, onExit }) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onStay} PaperProps={{ className: 'bank-transfer__exit-dialog' }}>
			<DialogTitle>{t('Bookings.SettlePayment.ExitConfirmTitle')}</DialogTitle>
			<DialogContent>{t('Bookings.SettlePayment.ExitConfirmText')}</DialogContent>
			<DialogActions className="bank-transfer__exit-dialog-actions">
				<Button variant="outlined" onClick={onStay}>
					{t('Bookings.SettlePayment.Stay')}
				</Button>
				<Button variant="outlined" color="error" onClick={onExit}>
					{t('Bookings.SettlePayment.Exit')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BankTransferExitConfirm;
